import moment from "moment-timezone";

const BUSINESS_TZ = "America/Los_Angeles";

// Parses "YYYY-MM-DD" or a Date instant as 9am Pacific, independent of the caller timezone.
export function toBusinessDate(dateStr) {
  if (!dateStr) return null;
  const calendarStr =
    dateStr instanceof Date
      ? moment.tz(dateStr, BUSINESS_TZ).format("YYYY-MM-DD")
      : dateStr;
  return moment
    .tz(calendarStr, "YYYY-MM-DD", BUSINESS_TZ)
    .add(9, "hours")
    .toDate();
}

// Formats a Firestore timestamp/ms/Date in Pacific, regardless of the viewer's browser timezone.
export function formatBusinessDate(value, fmt = "MM/DD/YY") {
  if (value == null) return "";
  const ms =
    typeof value === "number"
      ? value
      : value instanceof Date
      ? value.getTime()
      : value.seconds * 1000;
  return moment.tz(ms, BUSINESS_TZ).format(fmt);
}

// Today's date in Pacific, for date-picker defaults.
export function businessToday() {
  return moment.tz(BUSINESS_TZ).format("YYYY-MM-DD");
}
